// GENERATED from messaging-platform/packages/chat-core/src/photo-grid.ts. Do not edit here: edit there, then run scripts/sync-chat-core.cjs.
/**
 * How the photos of one message are laid out, WhatsApp's way: one on its own, two side by side, one wide over two, and
 * from four a 2 by 2 grid whose fourth tile reads "+N" when there are more (N counts that tile and those after it).
 * Tapping any tile opens a viewer over all of the message's photos, at that one.
 */
export type PhotoLayout = 'none' | 'single' | 'pair' | 'triple' | 'quad';

export interface PhotoGrid {
  layout: PhotoLayout;
  /** the ids drawn, in order */
  shown: string[];
  /** past four: the number on the fourth tile; 0 when every photo is drawn */
  more: number;
}

export function photoGrid(ids: readonly string[]): PhotoGrid {
  const layouts: PhotoLayout[] = ['none', 'single', 'pair', 'triple', 'quad'];
  const shown = ids.slice(0, 4);
  return { layout: layouts[shown.length] ?? 'quad', shown, more: ids.length > 4 ? ids.length - 3 : 0 };
}
